//@flow
import React, {forwardRef} from 'react';
import {Typography, makeStyles, ButtonBase} from '@material-ui/core';
import {Delete, DragIndicator} from '@material-ui/icons';
import IosSwitch from '../../../../elements/IosSwitch/IosSwitch';
import {colors} from '../../../../assets/styles/colors';

import {SortableKnob} from 'react-easy-sort';

const useStyles = makeStyles(theme => ({
  item: {
    background: colors.grey200,
    borderRadius: 12,
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: theme.spacing(2),
    userSelect: 'none',
    height: 48,
    position: 'relative',
    color: colors.grey800,
  },
  deleteIcon: {
    color: colors.grey600,
  },
  label: {
    color: colors.grey800,
    fontWeight: 500,
    fontSize: 14,
    flexGrow: 1,
  },
  deleteButton: {
    color: colors.danger,
  },
  successIcon: {
    color: colors.success,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  sectionLink: {
    flexGrow: 1,
    textDecoration: 'none',
    height: '100%',
    color: colors.grey800,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  dragIcon: {
    color: colors.grey600,
    cursor: 'grab',

    '&:active': {
      cursor: 'grabbing',
    },
  },
}));

type Props = {
  id: string,
  label: string,
  disabled?: boolean,
  draggable?: boolean,
  onDelete?: (id: string) => void,
  onToggle?: (id: string, checked: boolean) => void,
};

const StaticSectionItem = forwardRef<Props, any>(function SectionItem(
  props: Props,
  ref
) {
  const {id, label, disabled, draggable, onDelete, onToggle} = props;
  const classes = useStyles();

  return (
    <div className={classes.item} ref={ref}>
      {draggable && (
        <SortableKnob>
          <DragIndicator className={classes.dragIcon} />
        </SortableKnob>
      )}
      <a href={`#${id}`} className={classes.sectionLink}>
        <Typography className={classes.label}>{label}</Typography>
      </a>
      <div className={classes.itemOptions}>
        {onDelete && (
          <ButtonBase
            className={classes.deleteButton}
            onClick={() => {
              onDelete(id);
            }}
          >
            <Delete />
          </ButtonBase>
        )}
        {onToggle && (
          <IosSwitch
            size="small"
            checked={!disabled}
            onChange={() => {
              onToggle(id, !disabled);
            }}
            classes={{
              root: classes.switchRoot,
            }}
          />
        )}
      </div>
    </div>
  );
});

export default StaticSectionItem;
